import { cn } from '@shared/lib/cn';
import { formatConfidence } from '@shared/lib/format';

export interface ConfidenceBadgeProps {
  /** Niveau de confiance de l'extraction, entre 0 et 1. */
  confidence: number;
}

function levelOf(confidence: number): { label: string; classes: string; bar: string } {
  if (confidence >= 0.85) {
    return { label: 'élevé', classes: 'bg-emerald-100 text-emerald-800', bar: 'bg-emerald-500' };
  }
  if (confidence >= 0.6) {
    return { label: 'moyen', classes: 'bg-amber-100 text-amber-800', bar: 'bg-amber-500' };
  }
  return { label: 'faible', classes: 'bg-red-100 text-red-800', bar: 'bg-red-500' };
}

/**
 * Affiche le niveau de confiance de l'extraction IA (pourcentage + niveau).
 */
export function ConfidenceBadge({ confidence }: ConfidenceBadgeProps) {
  const percent = Math.round(confidence * 100);
  const level = levelOf(confidence);

  return (
    <div
      role="status"
      aria-label={`Confiance de l'extraction : ${percent} % (${level.label})`}
      className="flex items-center gap-3"
    >
      <span className={cn('rounded-full px-3 py-1 text-xs font-semibold', level.classes)}>
        Confiance : {formatConfidence(confidence)}
      </span>
      <div className="h-1.5 w-28 overflow-hidden rounded-full bg-slate-200" aria-hidden="true">
        <div className={cn('h-full rounded-full', level.bar)} style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}
